// App Configuration File
// This file contains all the configurable settings for the broker partners application

export const appConfig = {
  // Broker Partner Information
  broker: {
    name: "", // Set to empty string to show logo, or add broker name like "Alpha Global"
    shortName: "AP",
    description: "Broker Partnership Platform, Broker, Financial Market, Stock Market, Best Broker, Best Broker in UAE, Best broker in world",
    version: "1.0.0"
  },

  // Application Title
  title: "ABET Partners",

  // Color Theme Configuration
  theme: {
    // Primary Colors
    primary: {
      main: "#8b0000", // Dark Red
      light: "#8b0000", // Maroon
      dark: "#7f1d1d", // Red-800
      contrast: "#ffffff" // White text on primary
    },

    // Secondary Colors
    secondary: {
      main: "#22c55e", // Green-500 (for bullish)
      light: "#16a34a", // Green-600
      dark: "#15803d", // Green-700
      contrast: "#ffffff" // White text on secondary
    },

    // Bearish Colors (Red variations)
    bearish: {
      main: "#8b0000", // Maroon
      light: "#8b0000", // Maroon
      dark: "#7f1d1d", // Red-800
      contrast: "#ffffff"
    },

    // Bullish Colors (Green variations)
    bullish: {
      main: "#22c55e", // Green-500
      light: "#86efac", // Green-300
      dark: "#16a34a", // Green-600
      contrast: "#ffffff"
    },

    // Background Colors
    background: {
      light: {
        primary: "bg-gradient-to-br from-red-50 via-red-50 to-red-50",
        secondary: "bg-white/90",
        card: "bg-red-900/10",
        border: "border-red-300"
      },
      dark: {
        primary: "bg-black",
        secondary: "bg-black/90",
        card: "bg-red-900/10",
        border: "border-red-300"
      }
    },

    // Text Colors
    text: {
      light: {
        primary: "text-gray-900",
        secondary: "text-gray-600",
        accent: "text-red-800",
        muted: "text-gray-400"
      },
      dark: {
        primary: "text-white",
        secondary: "text-gray-300",
        accent: "text-red-400",
        muted: "text-gray-400"
      }
    },

    // Shadow Colors
    shadow: {
      light: {
        primary: "0 4px 20px rgba(139, 0, 0, 0.4)",
        secondary: "0 8px 32px rgba(139, 0, 0, 0.1)",
        card: "0 15px 45px rgba(139, 0, 0, 0.2)"
      },
      dark: {
        primary: "0 4px 20px rgba(248, 113, 113, 0.3)",
        secondary: "0 8px 32px rgba(248, 113, 113, 0.1)",
        card: "0 15px 45px rgba(248, 113, 113, 0.2)"
      }
    }
  },

  // Animation Settings
  animation: {
    duration: {
      fast: "0.3s",
      normal: "0.5s",
      slow: "1s"
    },
    easing: {
      ease: "ease-in-out",
      smooth: "cubic-bezier(0.4, 0, 0.2, 1)"
    }
  },

  // Layout Settings
  layout: {
    maxWidth: "max-w-xs",
    borderRadius: "rounded-xl",
    padding: "p-5",
    spacing: "space-y-4"
  },

  // Feature Flags
  features: {
    darkMode: true,
    languageSwitch: true,
    animations: true,
    particles: true,
    floatingCards: true,
    candlesticks: true
  }
};

// Helper functions to get theme colors
export const getThemeColor = (colorType, variant = 'main', isDarkMode = false) => {
  const theme = appConfig.theme;
  
  switch (colorType) {
    case 'primary':
      return theme.primary[variant];
    case 'secondary':
      return theme.secondary[variant];
    case 'bearish':
      return theme.bearish[variant];
    case 'bullish':
      return theme.bullish[variant];
    case 'background':
      return isDarkMode ? theme.background.dark[variant] : theme.background.light[variant];
    case 'text':
      return isDarkMode ? theme.text.dark[variant] : theme.text.light[variant];
    case 'shadow':
      return isDarkMode ? theme.shadow.dark[variant] : theme.shadow.light[variant];
    default:
      return theme.primary.main;
  }
};

// Helper function to get broker name
export const getBrokerName = () => {
  return appConfig.broker.name;
};

// Helper function to get broker short name
export const getBrokerShortName = () => {
  return appConfig.broker.shortName;
};

// Helper function to get application title
export const getAppTitle = () => {
  return appConfig.title;
};

export default appConfig;




